<div class="selected-range-view">
  <div class="selected-range-view__card">
    <span class="selected-range-view__card-text fs__md">{{
      values()[0] | optionValueOrText: surveyConditionalsService.questionSelected$() | toPlainText
    }}</span>
    <span class="fs__md">To</span>
    <span class="selected-range-view__card-text fs__md">{{
      values()[1] | optionValueOrText: surveyConditionalsService.questionSelected$() | toPlainText
    }}</span>
    <button mat-icon-button title="Clear selection" class="clear-button" (click)="onClearSelectedValues()">
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  </div>
</div>
